import { API_BASE_URL } from "../config/environment";

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(method, endpoint, body = null, headers = {}) {
    const url = `${this.baseURL}/${endpoint}`;
    const authToken = document.cookie
      .split("; ")
      .find((cookie) => cookie.startsWith("authToken="))
      ?.split("=")[1];
    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
        ...headers,
      },
      credentials: "include",
    };

    if (body) {
      if (body instanceof FormData) {
        delete options.headers["Content-Type"];
        options.body = body;
      } else {
        options.body = JSON.stringify(body);
      }
    }

    try {
      const response = await fetch(url, options);
      const text = await response.text();

      if (response.ok) {
        try {
          return JSON.parse(text);
        } catch (e) {
          return text;
        }
      } else {
        const errorData = JSON.parse(text);
        throw new Error(errorData.reason || errorData.message || "Request failed");
      }
    } catch (error) {
      console.error(`Error with ${method} request to ${endpoint}:`, error);
      throw error;
    }
  }

  async get(endpoint, headers = {}) {
    return this.request("GET", endpoint, null, headers);
  }

  async post(endpoint, body, headers = {}) {
    return this.request("POST", endpoint, body, headers);
  }

  async patch(endpoint, body, headers = {}) {
    return this.request("PATCH", endpoint, body, headers);
  }

  async put(endpoint, body, headers = {}) {
    return this.request("PUT", endpoint, body, headers);
  }

  async delete(endpoint, body = null, headers = {}) {
    return this.request("DELETE", endpoint, body, headers);
  }
}

export default ApiService;
